import { isProduction } from 'lib/utility/ApplicationConfig'

export const getAssetURL = (suffix: string): string => {
  const assetUrl = isProduction()
    ? `${process.env.REACT_APP_CLOUDFRONT_URL}${suffix}`
    : suffix

  return assetUrl
}
